import { managerTimesheet } from "../../Api/managerTimesheet";
import {
  FETCH_MANAGER_MONTHDATA_REQUEST,
  FETCH_MANAGER_MONTHDATA_FAILURE,
  FETCH_MANAGER_MONTHDATA_SUCCESS
} from "../../Constants";

function requestmanagerTimesheet() {
  return {
    type: FETCH_MANAGER_MONTHDATA_REQUEST,
    isFetching: true
  };
}

function managerTimesheetDataSuccess(data) {
  return {
    type: FETCH_MANAGER_MONTHDATA_SUCCESS,
    isFetching: false,
    data
  };
}

function managerTimesheetError(errorMessage) {
  return {
    type: FETCH_MANAGER_MONTHDATA_FAILURE,
    isFetching: false,
    errorMessage
  };
}

export const getManagerTimesheetData = payload => (dispatch, getState) => {
  dispatch(requestmanagerTimesheet());
  managerTimesheet
    .fetchManagerTimesheetData(payload)
    .then(res => {
      dispatch(managerTimesheetDataSuccess(res));
    })
    .catch(err => dispatch(managerTimesheetError(err)));
};
